import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAll(machineID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/machinekpisets?machineID=${machineID}`
      }))
  );
}

async function getById(kpiSetID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/machinekpisets/${kpiSetID}`
      }))
  );
}

async function create(kpiSet) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/machinekpisets',
        body: JSON.stringify(kpiSet)
      }))
  );
}

async function update(kpiSet) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/machinekpisets/${kpiSet.machineKPISetID}`,
        body: JSON.stringify(kpiSet)
      }))
  );
}

async function Delete(kpiSetID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/machinekpisets/${kpiSetID}`
      }))
  );
}

const shiftService = {
  getAll,
  getById,
  create,
  update,
  delete: Delete
};

export default shiftService;
